import React from 'react';
import { useSelector } from 'react-redux';
import { Col } from 'react-bootstrap';
import { QueryClientProvider } from 'react-query';
import ProspectiveList from './ProspectiveList';
import SalesQuoteList from './SalesQuoteList';
import ManagerQuoteList from './ManagerQuoteList';
import RecentlyClosed from './RecentlyClosed';
import OpenQuotesPie from './OpenQuotesPie';
import PostedQuotesPie from './PostedQuotesPie';
import FlexPanel from '../FlexPanel';
import browserHistory from '../../history';
import { modal } from '../modal/ModalEmitter';
import { getSalesRoles } from './util';
import FileNotFound from '../FileNotFound';
import SalesQueryClient from './SalesQueryClient';

const SalesDashboard = () => {
  const { user } = useSelector(state => state.app);
  const { isSalesPerson, isSalesManager } = getSalesRoles(user);


  if (!isSalesPerson && !isSalesManager) {
    return <FileNotFound>Sales Person or Sales Manager role required</FileNotFound>;
  }

  const quoteListToolbar = (
    <>
      <div className="card-toolbar-button" onClick={() => browserHistory.push('db/EQS1')}>
        <i className="fas fa-list-alt fa-fw" title="List" />
      </div>
      <div
        className="card-toolbar-button"
        onClick={() => {
          const presets = {};

          modal.open('quickCreate', {
            presets,
          });
        }}
      >
        <i className="fal fa-plus fa-fw" title="Add New Quote" />
      </div>
    </>
  );

  const customerListToolbar = (
    <>
      <div
        className="card-toolbar-button"
        onClick={() => {
          browserHistory.push('db/EQS5/new');
        }}
      >
        <i className="fal fa-plus fa-fw" title="Add New Customer" />
      </div>
    </>
  );

  return (
    <QueryClientProvider client={SalesQueryClient}>
      <div className="sales-dashboard">
        <Col lg={8} md={12} className="mb-3">
          {isSalesManager ? (
            <ManagerQuoteList toolbar={quoteListToolbar} />
          ) : (
            <SalesQuoteList toolbar={quoteListToolbar} />
          )}
        </Col>
        <Col lg={4} md={12} className="mb-3">
          <ProspectiveList toolbar={customerListToolbar} />
        </Col>
        {isSalesManager ? (
          <Col lg={4} className="mb-3">
            <FlexPanel header="Open Quotes">
              <OpenQuotesPie />
            </FlexPanel>
          </Col>
        ) : (
          <Col lg={8} className="mb-3">
            <FlexPanel header="My Posted">
              <PostedQuotesPie />
            </FlexPanel>
          </Col>
        )}
        {isSalesManager && (
          <Col lg={8} className="mb-3">
            <RecentlyClosed />
          </Col>
        )}
      </div>
    </QueryClientProvider>
  );
};

export default SalesDashboard;
